/**
 * @class
 * @description class being used for each single crop
 * @param {Node} args.element the outer element of this crop
 * @param {Object} args.data the JSON data of this crop
 * @param {Object} args.translations text translations object
 */
export default class Cropdate {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;
    this.user = args.user;
    this.translations = args.translations;

    this.render();
  }

  render() {
    this.element.classList.add('item');
    this.element.innerHTML = this.template;
  }

  get template() {
    return `
      <div class="country">
        <b>${this.translations.country}:</b>
        <img class="flag-icon" src="/projects/application/dist/images/icons/flags/4x3/${this.data.country_short.toLowerCase()}.svg" alt="">
        <span>${this.data.country_name}</span>
      </div>
      <div class="region ${this.data.region ? `` : `empty`}"><b>${this.translations.region}:</b> ${this.data.region || ``}</div>
      <div class="date-from"><b>${this.translations.from}:</b> ${moment(this.data.start_date).format('L')}</div>
      <div class="date-till"><b>${this.translations.till}:</b> ${moment(this.data.end_date).format('L')}</div>
    `;
  }
}